import Vue from 'vue';
import VueRouter from 'vue-router';
import home from './home/route';
import notFound from "./notFound/route"
import welfare from "./welfare/route"
const base_url = process.env.BASE_URL
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history', 
    base: base_url, 
    routes: [{
            path: '*',
            redirect: '/404'
        },
        {
            path: '/',
            redirect: '/home'
        },
        home,
        welfare,
        notFound
    ]
});

export default router;